// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { localize } from 'i18n-calypso'

// Internal Dependencies:
import Editable from 'church-theme-library/components/Editable/Editable'
import PostSectionB from 'church-theme-library/components/PostSections/PostSectionB'
// import Image from 'church-theme-library/components/Image/Image'
import { get, loop } from 'church-theme-library/utilities/objects'

// Redux:
import { getPageData } from 'church-theme-library/redux/actions/page'

class LatestNewsAndEvents extends React.Component {
	componentDidMount() {
		const { dispatch } = this.props

		dispatch(
			getPageData( {
				type: 'posts',
				isArchive: true,
				slug: 'latest',
				categorySlug: '',
				number: 4,
				archivePageNumber: false,
				requestOnly: true
			} )
		)
	}

	render() {
		const { contentId, sectionId, data, translate, postsArray, slugs } = this.props

		return (
			<div className="section-latest-posts">
				<div className="-heading">
					<div className="-inner">
						<div className="-text">
							<Editable
								element="h2"
								id={ contentId }
								sectionId={ sectionId }
								sectionType={ data.type }
								sectionDataId="heading"
								content={ data.heading }
							/>

							<p className="with-button">
								<Link to={ `/${slugs.news}` } className="button is-mini">{ translate( 'View more' ) }</Link>
							</p>
						</div>
					</div>
				</div>

				<div className="-posts">
					<PostSectionB type="posts" posts={ postsArray } showDateSelect={ false } disableLoadMorePosts={ true } />
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	const numberOfPosts = 3
	const postsById = get( ['archiveCategoriesById', 'id_posts_latest', 'items'] )( state.page )
	let postsArray = []

	if ( postsById ) {
		postsArray = Object.keys( postsById ).slice( 0, numberOfPosts ).map( ( key ) => {
			return postsById[ key ]
		} )
	}

	return {
		postsArray,
		slugs: state.site.slugs
	}
}

export default localize(
	connect( mapStateToProps )( LatestNewsAndEvents )
)
